export default __webpack_public_path__ + "static/stubai.logo-272e0c1a62fab28ab8ff6c2f3ed84e71.png";